export const paginationFilter = (current, itemsPage, totalItems) =>(
    <h5>Mostrando: <span>{current}&nbsp;-&nbsp;{itemsPage}</span> de {totalItems} productos, según filtro aplicado</h5>
)